import Placeholder from './Placeholder';
import PlaceholderGraph from './PlaceholderGraph';
import PlaceholderGrid from './PlaceholderGrid';
import PlaceholderParagraph from './PlaceholderParagraph';

// export types
export type { PlaceholderGraphProps } from './PlaceholderGraph';
export type { PlaceholderGridProps } from './PlaceholderGrid';
export type { PlaceholderParagraphProps } from './PlaceholderParagraph';

// export components
export { Placeholder, PlaceholderParagraph, PlaceholderGrid, PlaceholderGraph };
export default Placeholder;
